<script>
  import { scaleLinear } from "d3";
  export let min;
  export let max;

  $: mid = Math.round((max - min) / 2);
</script>

<div class="axis">
  <p>{max} medals</p>
</div>

<style>
  .axis {
    /* display: flex;
    justify-content: space-between;
    padding-left: 13em; */
    /* font-size: 1.25em; */
    /* opacity: 0.75; */
    margin-bottom: 0.25em;
    /* width: 95%; */
  }

  .axis p {
    /* font-size: 0.75em; */
    /* transform: translate(-1.5em, 0); */
    text-align: right;
  }
</style>
